import {
  GetPatientNoteListActionTypes,
  PATIENT_NOTE_LIST_FAIL,
  PATIENT_NOTE_LIST_LOADING,
  PATIENT_NOTE_LIST_SUCCESS,
  GetPatientNoteListState,
  PATIENT_NOTE_LIST_UPDATE_API_MSG,
  PATIENT_NOTE_LIST_UPDATE_API_RES,
} from "./ActionTypes";
import { GetPatientNoteListRes } from "./Model";

const initialStateGetPosts: GetPatientNoteListState = {
  loading: false,
  getPatientNoteList: {} as GetPatientNoteListRes,
  successMsg: "",
  errorMsg: "",
  status: 0,
};
export const getPatientNoteListReducer = (
  state = initialStateGetPosts,
  action: GetPatientNoteListActionTypes
): GetPatientNoteListState => {
  switch (action.type) {
    case PATIENT_NOTE_LIST_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case PATIENT_NOTE_LIST_SUCCESS:
      return {
        ...state,
        getPatientNoteList: action.payload,
        successMsg: action.successMsg,
      };
    case PATIENT_NOTE_LIST_FAIL:
      return {
        ...state,
        getPatientNoteList: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case PATIENT_NOTE_LIST_UPDATE_API_MSG:
      return {
        ...state,
        getPatientNoteList: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case PATIENT_NOTE_LIST_UPDATE_API_RES:
      return {
        ...state,
        getPatientNoteList: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};
